









































import { Component, Prop, Vue } from 'vue-property-decorator'
import { GamePlayerData } from '@/class/gamePlayer'
import { Vote } from '@/class/game'

@Component
export default class VoteViewer extends Vue {
  @Prop() playerOf!: {[id: string]: GamePlayerData};
  @Prop() votedData!: Vote;

  get votedDataList () {
    return this.makeVotedDataList(this.votedData)
  }

  public makeVotedDataList (voteData: Vote) {
    const voted: Array<{playerId: string; votedPlayerIds: string[]}> = []
    Object.keys(voteData.vote).forEach((key) => {
      voted.push({ playerId: key, votedPlayerIds: voteData.vote[key] })
    })
    return voted.sort((a, b) => b.votedPlayerIds > a.votedPlayerIds? 1: -1 ).sort((a, b) => b.votedPlayerIds.length - a.votedPlayerIds.length)
  }

  getPlayerName (id: string) {
    return this.playerOf[id].name
  }
}
